// Native replacement for Quasar's q-item base styling (ENG-20662).
// Reproduces the q-item layout/spacing contract the existing call sites
// relied on; per-page overrides layer on top via the .m-item selector.
.m-item {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  min-height: 48px;
  padding: 8px 16px;
  color: inherit;
  text-decoration: none;
  position: relative;
  transition:
    color 0.3s,
    background-color 0.3s;

  &--clickable {
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background-color: var(--hover-background, rgba(0, 0, 0, 0.04));
    }

    &:focus-visible {
      outline: 0;
      background-color: var(--hover-background, rgba(0, 0, 0, 0.04));
    }
  }

  &--dense {
    min-height: 32px;
    padding: 2px 16px;
  }

  &--focused {
    background-color: var(--hover-background, rgba(0, 0, 0, 0.08));
  }

  &--disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.6;
  }
}
